import { render } from "./Preloader.vue?vue&type=template&id=0b67e3f3&scoped=true"
import script from "./Preloader.vue?vue&type=script&lang=js"
export * from "./Preloader.vue?vue&type=script&lang=js"

import "./Preloader.vue?vue&type=style&index=0&id=0b67e3f3&lang=scss&scoped=true"

import exportComponent from "/Users/pavel/FrontReportTechnomoscow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b67e3f3"]])

export default __exports__